(function () {
  const ROOT_SEL = '.customily_option.custom-design-color';

  function contrastText(rgb) {
    const m = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(rgb || '');
    if (!m) return '#fff';
    const r = +m[1], g = +m[2], b = +m[3];
    const L = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
    return L > 0.6 ? '#111' : '#fff';
  }

  function init(root) {
    if (!root || root.dataset.ropeReady) return;
    root.dataset.ropeReady = '1';

    const content = root.querySelector('.cl-option-content');
    if (!content) return;

    /* Rope bar */
    const bar = document.createElement('div');
    bar.className = 'rope-bar';
    bar.innerHTML = `
      <div class="rope-left">
        <span class="rope-value">Select Color</span>
      </div>
      <button type="button" class="rope-toggle" aria-expanded="false">
        <img src="https://cdn.shopify.com/s/files/1/0759/0582/7052/files/Frame_30.png?v=1751538761" width="15" height="15">
        Change Color
      </button>
    `;
    root.insertBefore(bar, content);

    const btn = bar.querySelector('.rope-toggle');
    const valueEl = bar.querySelector('.rope-value');

    function applyFromChecked() {
      /* 🔥 ONLY truth: checked radio */
      const checked = root.querySelector('input[type="radio"]:checked');
      if (!checked) return;

      const label = root.querySelector(`label[for="${checked.id}"]`);
      if (!label) return;

      /* ✅ NAME */
      valueEl.textContent = checked.value || 'Color';

      /* ✅ COLOR (inline bg from label) */
      const bg = label.style.backgroundColor;
      if (bg) {
        const contrast = contrastText(bg);
        bar.style.backgroundColor = bg;
        bar.style.color = contrast;
        bar.style.borderColor =
          contrast === '#111' ? '#ccc' : 'transparent';
      }
    }

    /* Toggle open / close (as-is) */
    btn.addEventListener('click', () => {
      root.classList.toggle('is-open');
      btn.setAttribute(
        'aria-expanded',
        String(root.classList.contains('is-open'))
      );
      applyFromChecked();
    });

    /* Radio change */
    root.addEventListener('change', e => {
      if (e.target.matches('input[type="radio"]')) {
        requestAnimationFrame(applyFromChecked);
      }
    });

    /* Swatch click (Customily async safe) */
    root.addEventListener('click', e => {
      const label = e.target.closest('label');
      if (!label) return;

      const id = label.getAttribute('for');
      const radio = id && document.getElementById(id);
      if (!radio) return;

      setTimeout(applyFromChecked, 0);
    });

    /* Initial paint */
    root.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    applyFromChecked();
  }

  function boot() {
    document.querySelectorAll(ROOT_SEL).forEach(init);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  new MutationObserver(boot).observe(document.body, {
    subtree: true,
    childList: true
  });
})();

window.addEventListener('customily-options-loaded', function (e) {
 $('#cl_optionsapp .customily_option.custom-checbox .swatch-container .customily-swatch label').each(function () {
        $(this).attr('style', '');
    });

});
window.addEventListener('customily-options-loaded', function () {

  function removeBorder(el) {
    el.style.setProperty('border', 'none', 'important');
  }

  // Initial run
  document.querySelectorAll('.custom-checbox .customily-swatch label')
    .forEach(removeBorder);

  // Observe changes (important for click)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        const el = mutation.target;
        if (el.matches('.custom-checbox .customily-swatch label')) {
          removeBorder(el);
        }
      }
    });
  });

  // Attach observer
  document.querySelectorAll('.custom-checbox .customily-swatch label')
    .forEach(el => {
      observer.observe(el, {
        attributes: true,
        attributeFilter: ['style']
      });
    });

});

window.addEventListener('customily-options-loaded', function () {

  let isUpdating = false;

  function setValue(el, val) {
    if (el.value === val) return;

    isUpdating = true;

    Object.getOwnPropertyDescriptor(el.__proto__, 'value').set.call(el, val);
    el.dispatchEvent(new Event('input', { bubbles: true }));

    setTimeout(() => {
      isUpdating = false;
    }, 0);
  }

  function getSelectedFont() {
    return document.querySelector('.custom-font-style input:checked');
  }

  function getTextInput() {
    return document.querySelector('.customily_option.custom-text input[type="text"]');
  }

  function capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
  }

  function updateText(force = false) {
    const font = getSelectedFont();
    const input = getTextInput();
    if (!font || !input) return;

    // ✅ Block + Roman Monogram → uppercase
    if (font.value === "Block" || font.value === "Roman Monogram") {
      setValue(input, input.value.toUpperCase());
    } 
    else if (force) {
      setValue(input, capitalize(input.value));
    }
  }

  // 👉 Font change
  document.body.addEventListener('change', function (e) {
    if (e.target.closest('.custom-font-style')) {
      updateText(true);
    }
  });

  // 👉 Typing
  document.body.addEventListener('input', function (e) {
    if (isUpdating) return;

    if (e.target.closest('.customily_option.custom-text') && e.target.type === "text") {

      const font = getSelectedFont();

      // ✅ Block + Roman Monogram → uppercase while typing
      if (font && (font.value === "Block" || font.value === "Roman Monogram")) {
        setValue(e.target, e.target.value.toUpperCase());
      }
    }
  });

});

